@if (willEnter()) {
  <ion-datetime-button [datetime]="'datetime-' + id()"></ion-datetime-button>
}

<ion-modal [keepContentsMounted]="true">
  <ng-template>
    <ion-datetime #datetime
      [id]="'datetime-' + id()"
      presentation="date"
      [locale]="locale$ | async"
      [firstDayOfWeek]="1"
      [value]="currentDayISO"
      (ionChange)="onDayChange($event)">
      <ion-buttons slot="buttons">
        <ion-button color="medium"
          (click)="datetime.cancel(true)">{{ 'general.cancel' | translate }}</ion-button>
        <ion-button color="medium"
          (click)="datetime.confirm(true)">{{ 'general.done' | translate }}</ion-button>
      </ion-buttons>
    </ion-datetime>
  </ng-template>
</ion-modal>